<template>
  <div id="resetPasswordWrapper">
    <div class="box">
      <label class="label">Wachtwoord wijzigen</label>

      <div class="field">
        <div class="control">
          <input class="input" type="password" v-model="password" placeholder="Nieuw wachtwoord">
        </div>

        <template v-if="hasMinChars && !isStrong">
          <p class="help"><strong class="has-text-danger">Het gekozen wachtwoord is niet sterk genoeg.</strong></p>
          <p class="help">Een sterk wachtwoord voldoet aan de volgende eisen, minstens:</p>
          <ul class="help">
            <li>- 8 karakters lang</li>
            <li>- 1 kleine letter</li>
            <li>- 1 hoofdletter</li>
            <li>- 1 cijfer</li>
            <li>- 1 speciaal karakter zoals $^*@#</li>
          </ul>
        </template>
      </div>

      <div class="field">
        <div class="control">
          <input class="input" type="password" v-model="password_verification" placeholder="Voer nogmaals het wachtwoord in ter controle">
        </div>
      </div>

      <save-buttons
        @save="save"
        :noCancel="true"
        :disabled="!valid"
        saveCaption="Wachtwoord opslaan">
      </save-buttons>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  components: {
    SaveButtons
  },
  data () {
    return {
      password: null,
      password_verification: null
    }
  },
  computed: {
    ...mapGetters({
      saved: 'account/saved'
    }),
    valid () {
      return this.password && this.isStrong && this.matches
    },
    hasMinChars () {
      return this.password !== null && this.password.length >= 8
    },
    isStrong () {
      return new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})').test(this.password)
    },
    matches () {
      return this.password === this.password_verification
    }
  },
  watch: {
    saved () {
      if (this.saved) {
        this.password = this.password_verification = null
      }
    }
  },
  methods: {
    save () {
      this.$store.dispatch('account/reset', {
        password: this.password,
        password_verification: this.password_verification
      })
    }
  }
}
</script>
